var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPlayList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 6c0-.552.421-1 .941-1h6.118c.52 0 .941.448.941 1s-.421 1-.941 1H12.94c-.519 0-.94-.448-.94-1m-8 6c0-.552.421-1 .941-1H19.06c.52 0 .941.448.941 1s-.421 1-.941 1H4.94c-.519 0-.94-.448-.94-1m0 6c0-.552.421-1 .941-1H19.06c.52 0 .941.448.941 1s-.421 1-.941 1H4.94c-.519 0-.94-.448-.94-1",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.376 5.584 4.777 2.518A.5.5 0 0 0 4 2.934v6.132a.5.5 0 0 0 .777.416l4.599-3.066a.5.5 0 0 0 0-.832"
})));
export default SvgIcPlayList;